// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"5d588e889ef7ef076537","678":"89147446238981cdfb49","883":"bae2968e7588bfc83b63"}[chunkId] + ".js";
};